import './bootstrap.min.css';
import './App.css';
import logo from './item_logo.png';
import CloudSaver from './components/wmx-cloudsaver';

function App() {
  return (
    <div className="App">
      <header>
        <div className="navbar navbar-dark bg-dark shadow-sm">
          <div className="container d-flex justify-content-between">
            <a href="/" className="navbar-brand d-flex align-items-center">
             <img src={logo} alt="react-cloud-saver" width="192" />
            </a>
            <a className="btn btn-success" href="https://themeknit.com/product/react-cloud-saver-react-component-for-file-sharing"><span className="fa fa-shopping-cart"></span> Buy Now for $12</a>
          </div>
        </div>
      </header>
      <main role="main">

        <section className="jumbotron text-center">
          <div className="container">
            <h1 className="mb-4">Demonstration</h1>
            <p className="lead text-muted mb-4">React Cloud Saver plugin is useful in many cases. You can integrate easily into your existing react application. Here you can see this plugin in action.</p>
            <p className="mb-4">
              <a href="https://themeknit.com/product/react-cloud-saver-react-component-for-file-sharing" className="btn btn-success btn-lg my-2"><span className="fa fa-shopping-cart"></span> BUY NOW FOR $12</a>
            </p>
            <p className="text-muted small">** Images are for demonstration purposes only **</p>
          </div>
        </section>

        <div className="album py-10 bg-light">
          <div className="container">
            <div className="row mb-2">
                <div className="col-md-6">
                  <div className="row no-gutters border rounded overflow-hidden flex-md-row mb-6 shadow-sm h-md-250 position-relative">
                    <div className="col-auto d-none d-lg-block">
                      <img src="https://koder.top/addtocalendar/wp-content/uploads/2021/04/time_magazine.jpg" alt="time-magazine"/>
                    </div>
                    <div className="col p-3 d-flex flex-column position-static text-left bg-white">
                      <h3>Time Magazine</h3>
                      <p className="text-muted">April 2021 Issue</p>
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.</p>
                      <CloudSaver isdrive={true} isdropbox={true} file="https://koder.top/addtocalendar/wp-content/uploads/2021/04/PRESSR_TJ_Apr2021.pdf" filename="PRESSR_TJ_Apr2021.pdf" sitename="React App" dropboxapi="a1jy330vpyki64r"/>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="row no-gutters border rounded overflow-hidden flex-md-row mb-6 shadow-sm h-md-250 position-relative">
                    <div className="col-auto d-none d-lg-block">
                      <img src="https://koder.top/addtocalendar/wp-content/uploads/2021/04/ovr_white_paper.jpg" alt="ovr-white-paper" height="259"/>
                    </div>
                    <div className="col p-3 d-flex flex-column position-static text-left bg-white">
                      <h3>OVR White Paper</h3>
                      <p className="text-muted">Update March 2021</p>
                      <p>OVR is a digital layer covering the entire globe. It’s composed of 1.6 trillion unique hexagons called OVRLands.</p>
                      <CloudSaver isdrive={true} isdropbox={true} file="https://koder.top/addtocalendar/wp-content/uploads/2021/04/ovr_whitepaper_3.0.pdf" filename="ovr_whitepaper_3.0.pdf" sitename="React App" dropboxapi="a1jy330vpyki64r"/>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="row no-gutters border rounded overflow-hidden flex-md-row mb-6 shadow-sm h-md-250 position-relative">
                    <div className="col-auto d-none d-lg-block">
                      <img src="https://koder.top/addtocalendar/wp-content/uploads/2021/04/530-album-cover-300x300.jpg" alt="ovr-white-paper" width="192" height="211" />
                    </div>
                    <div className="col p-3 d-flex flex-column position-static text-left bg-white">
                      <h3>530 Music Albums</h3>
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.</p>
                      <CloudSaver isdrive={true} isdropbox={true} file="https://koder.top/addtocalendar/wp-content/uploads/2021/04/bensound-dubstep_music.zip" filename="bensound-dubstep_music.zip" sitename="React App" dropboxapi="a1jy330vpyki64r"/>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="row no-gutters border rounded overflow-hidden flex-md-row mb-6 shadow-sm h-md-250 position-relative">
                    <div className="col-auto d-none d-lg-block">
                      <img src="https://koder.top/addtocalendar/wp-content/uploads/2021/04/weekly_design_freebies_pa-243x300.jpg" alt="ovr-white-paper" width="192" height="211" />
                    </div>
                    <div className="col p-3 d-flex flex-column position-static text-left bg-white">
                      <h3>Weekly Design Freebies</h3>
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.</p>
                      <CloudSaver isdrive={true} isdropbox={true} file="https://koder.top/addtocalendar/wp-content/uploads/2021/04/weekly_design_freebies_pa.zip" filename="weekly_design_freebies_pa.zip" sitename="React App" dropboxapi="a1jy330vpyki64r"/>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>

      </main>

      <footer className="text-muted">
        <div className="container">
          <p className="text-center">
            Copyright <span className="st">&copy;</span>2021 Koder. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;
